import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { TableGruposR } from "../../../components/Alumnos/ReinscripcionGrupos/TableGruposR";
import { Loader, Message } from "semantic-ui-react";

function ReinscripcionAlumnos() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaReinscripcionAlumnos />;
}

function LogicaReinscripcionAlumnos() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [grupos, setGrupos] = useState(null);

  const [periodoIR, setperiodoIR] = useState({});

  const currentDate = new Date(); // Obtener la fecha y hora actual

  // Verificar si la fecha actual está dentro del período de reinscripción
  const dentroPeriodoReinscripcion =
    currentDate >=
      new Date(periodoIR.fecha_inicio + "T" + periodoIR.hora_inicio) &&
    currentDate <= new Date(periodoIR.fecha_fin + "T" + periodoIR.hora_fin);

  async function getPeriodo() {
    try {
      const response = await axios.get(
        `${BASE_API}/api/periodo_reinscripcion/`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      // Filtrar el periodo de reinscripción con id igual a 3
      const periodoR = result[0];

      // Verificar si se encontró el periodo de reinscripción
      if (periodoR) {
        // Establecer el periodo de reinscripción encontrado como objeto
        setperiodoIR({
          id_periodo_reinscripcion: periodoR.id_periodo_reinscripcion,
          fecha_inicio: periodoR.fecha_inicio,
          hora_inicio: periodoR.hora_inicio,
          fecha_fin: periodoR.fecha_fin,
          hora_fin: periodoR.hora_fin,
        });
      } else {
        setperiodoIR(null);
      }
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }
  useEffect(() => {
    getPeriodo();
    // eslint-disable-next-line
  }, [refetch]);

  async function getGruposApi() {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const result = response.data;
      setLoading(false);
      setGrupos(result);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getGruposApi();
    // eslint-disable-next-line
  }, [refetch]);

  const gestionarGrupo = async (data) => {
    navigate("/ReinscripcionAlumnos/ListaAlumnosGrupo", {
      state: { datosGrupo: data },
    });
  };

  let renderizarContenido;
  if (dentroPeriodoReinscripcion) {
    // Si estamos dentro del período de reinscripción, mostrar el contenido normal
    renderizarContenido = (
      <div>
        <h1 className="tituloin">Reinscripciones por grupo</h1>
        {loading ? (
          <Loader active inline="centered">
            Cargando....
          </Loader>
        ) : (
          <TableGruposR grupos={grupos} gestionarGrupo={gestionarGrupo} />
        )}
      </div>
    );
  } else {
    renderizarContenido = (
      <div>
        <Message
          info
          header="El período de reinscripción aún no llega o ya ha finalizado"
          content="Consulte con el administrador si es que se trata de un error"
        />
      </div>
    );
  }

  return renderizarContenido;
}

export default ReinscripcionAlumnos;
